module.exports = __webpack_public_path__ + "media/images/gather-your-documents-image-1cb9e73f.svg";